import { DailyReportingScreen } from "app/screens/residents/show/DailyReportingScreen";

export default function DailyReportingPage() {
  return <DailyReportingScreen />;
}
